import * as Sentry from '@sentry/vue';

// Sincroniza o usuário autenticado com o escopo do Sentry para que cada
// issue mostre contagem real de "Users Affected" e os filtros por usuário
// funcionem. Roda depois do 01-auth para garantir que a store já existe.
export default defineNuxtPlugin(() => {
  // Sentry desativado temporariamente — reativar removendo este return.
  return;

  const { user } = storeToRefs(useUserDataStore());

  watch(
    user,
    (current) => {
      if (current?.id) {
        Sentry.setUser({ id: String(current.id) });
      } else {
        Sentry.setUser(null);
      }
    },
    { immediate: true },
  );
});
